import { render, staticRenderFns } from "./Form18Layout.vue?vue&type=template&id=c66f7e54&scoped=true"
import script from "./Form18Layout.vue?vue&type=script&lang=ts"
export * from "./Form18Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=c66f7e54&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66f7e54",
  null
  
)

export default component.exports